import { Quasar, Notify, Dialog } from "quasar";

// Icons
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/material-icons-outlined/material-icons-outlined.css";

// Styles
import "quasar/src/css/index.sass";

// Language
import nl from "quasar/lang/nl";

export default {
  install: (app) => {
    app.use(Quasar, {
      lang: nl,
      plugins: {
        Notify,
        Dialog,
      },
      config: {
        notify: {
          position: "bottom",
          timeout: 3000,
        },
      },
    });

    Notify.registerType("positive", {
      icon: "check",
      color: "positive",
      textColor: "white",
      actions: [{ icon: "close", color: "white" }],
    });

    Notify.registerType("warning", {
      icon: "warning",
      color: "orange",
      textColor: "black",
      actions: [{ icon: "close", color: "black" }],
    });

    Notify.registerType("negative", {
      icon: "warning",
      color: "negative",
      textColor: "white",
      actions: [{ icon: "close", color: "white" }],
    });
  },
};
